export const paths = {
    addOrEditFamily: '/family/update',
    admin: '/admin',
    adminBilling: '/admin/billing',
    adminGroups: '/admin/groups',
    adminGroupsAdd: '/admin/groups/create',
    adminGroupsEdit: '/admin/groups/edit/:id',
    adminGroupsEditBase: '/admin/groups/edit',
    adminGroupsManageCollab: '/admin/groups/edit/user/:id',
    adminGroupsManageCollabBase: '/admin/groups/edit/user',
    adminGroupsTravelPolicy: '/admin/groups/travel_policy',
    adminImportBulk: '/admin/import_bulk',
    adminImportBulkPrepare: '/admin/prepare/import_bulk',
    adminUsers: '/admin/users',
    adminUsersAdd: '/admin/users/create',
    adminUsersAssociate: '/admin/users/associate',
    adminUsersEdit: '/admin/users/edit',
    adminPayment: '/admin/payment',
    adminEditPayment: '/admin/payment_edit',
    adminPaymentAdyenNew: '/admin/payment/new_payment',
    billing: '/billing',
    company: '/company',
    concur: '/concur',
    debug: '/debug',
    family: '/family',
    favoriteCreateOrEdit: '/favorites/update',
    favorites: '/favorites',
    hb: '/hb',
    home: '/home',
    homeAssistance: '/home/assistance',
    homeConfirm: '/home/confirm',
    homeConfirmDetail: '/home/confirm/:id',
    homeDriverMessage: '/home/message',
    homeDriverSearch: '/home/driver_search',
    homeMad: '/home/mad',
    homeNewFavoriteBase: '/home/favorites',
    homeNewFavorite: '/home/favorites/:type',
    homePassengers: '/home/passengers',
    homePassengersAddMember: '/home/passengers/add',
    homePassengersAddGuestMember: '/home/passengers/add_guest',
    homePayment: '/home/payment',
    homePaymentAddCard: '/home/payment/add',
    homePoiMeetingPoint: '/home/poi/meeting_point',
    homePoiMeetingPointFull: '/home/poi/meeting_point_full',
    homePoiNumber: '/home/poi/number',
    homePoiPancarte: '/home/poi/pancarte',
    homePoiRecap: '/home/poi/meeting_point_recap',
    homePoliciesNoRide: '/home/policies_no_ride',
    homeRideReason: '/home/reason',
    homeSchedule: '/home/schedule',
    homeScheduleFlight: '/home/schedule_flight',
    homeScheduleFlightInfo: '/home/schedule_flight/info',
    homeScheduleFlightTime: '/home/schedule_flight/time',
    homeScheduleFlightAdditional: '/home/schedule_flight/more',
    homeScheduleStation: '/home/schedule_station',
    homeRecurrence: '/home/recurrence',
    homeService: '/home/service',
    params: '/params',
    payment: '/payment',
    paymentAdyenNew: '/payment/new_payment',
    paymentEditCard: '/payment/edit_card',
    paymentRedirect: '/payment/redirect_payment',
    profile: '/profile',
    profileCheckMail: '/profile/check_your_mailbox/',
    profileEditInfos: '/profile/edit_infos/',
    profileEditPhone: '/profile/edit_phone',
    profileEditPwd: '/profile/edit_pwd/',
    profileValidateCode: '/profile/validate_code/',
    profileValidatePhone: '/profile/validate_phone/',
    profileLegalInfos: '/profile/legal_infos/',
    promo: '/promo',
    reservations: '/reservations',
    reservationsDetail: '/reservations/:id',
    reservationsRecurrentDetail: '/reservations/recurrent/:id',
    reservationsEditDriverMessage: '/reservations/:id/message',
    reservationsEditMeetingPoint: '/reservations/:id/meeting_point',
    reservationsEditPassengers: '/reservations/:id/passengers',
    reservationsEditPayment: '/reservations/:id/payment',
    reservationsEditPoiNumber: '/reservations/:id/poi_number',
    reservationsEditRideReason: '/reservations/:id/reason',
    rideTrackingMobile: '/ride_tracking', // Unused anymore it seems
    homeTrackingMobile: '/tracking_mobile/:id',
    root: '/',
    rootWebView: '/index.html',
    selfServiceCompany: '/self_service',
    selfServiceFormula: '/self_formula',
    selfServiceSignContract: '/self_sign_contract',
    selfServiceWelcome: '/self_welcome',
    selfServicePayment: '/self_payment',
    selfServicePaymentSettings: '/self_payment_settings',
    selfServicePolicies: '/self_policies',
    sos: '/sos',
    support: process.env.REACT_APP_URL_FAQ ?? '/support',
    tripHistory: '/history',
    tripHistoryDetail: '/history/:id',
};
